import { Response } from '@/core'
import { PackageApiBuilder } from './package.api.types'
import {
  AddAddonsParams,
  AddOnType,
  RemoveAddonsParams,
  TicketListParams as AddonsListParams,
} from './package.api.tickets.types'

export const addonsEndpoints = (builder: PackageApiBuilder) => ({
  getAddonsList: builder.query<Response<AddOnType[]>, AddonsListParams>({
    query: ({ sessionId, eventId, modify, noCache }: AddonsListParams) => ({
      url: `/package/addons/${eventId}/list`,
      method: 'get',
      params: { sessionId, modify, noCache },
    }),
  }),
  addAddons: builder.mutation<Response<string>, AddAddonsParams>({
    query: ({ sessionId, addons }: AddAddonsParams) => ({
      url: `/package/addons/add-addons`,
      method: 'post',
      params: { sessionId },
      data: { addons },
    }),
  }),
  removeAddons: builder.mutation<Response<string>, RemoveAddonsParams>({
    query: ({ sessionId, addonId }: RemoveAddonsParams) => ({
      url: `/package/addons/remove-addons`,
      method: 'put',
      params: { sessionId, addonId },
    }),
  }),
})
